module.exports = __webpack_public_path__ + "images/0cdf024ac1f6bba713389219a73afb1e-logo.png";